import { useContext } from 'react';
import { PublisherContext } from './Context';
var usePublisher = function usePublisher() {
  return useContext(PublisherContext);
};
export default usePublisher;